import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';
import { MapContext } from "providers/MapProvider";
import { ME_QUERY } from "graphql/APICalls";

// Define the GraphQL query for the login
const LOGOUT_MUTATION = gql `mutation Logout { logout }`

function LogOut(){

  const { updateLocation } = useContext(MapContext);

  const navigate = useNavigate();

  const [sendLogoutMutation, logoutMutation] = useMutation(LOGOUT_MUTATION);
  
  useEffect(() => {
    sendLogoutMutation({
      fetchPolicy: 'network-only',
      onCompleted: () => { updateLocation(); navigate('/') },
      refetchQueries: [ { query: ME_QUERY } ]
    });
  });
 
  return <>
    <h1>Log out</h1>
    <div>
      {logoutMutation.loading ? 'Logging out ...' :
        logoutMutation.error   ? 'Some error occurred' :
        logoutMutation.data?.logout ? 'Successfully logged out' :
        'Something unexpected happened'}
      </div>
    </>
}

export default LogOut